import { render, staticRenderFns } from "./InformationNote.vue?vue&type=template&id=05838f2d&scoped=true"
import script from "./InformationNote.vue?vue&type=script&lang=js"
export * from "./InformationNote.vue?vue&type=script&lang=js"
import style0 from "./InformationNote.vue?vue&type=style&index=0&id=05838f2d&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05838f2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05838f2d')) {
      api.createRecord('05838f2d', component.options)
    } else {
      api.reload('05838f2d', component.options)
    }
    module.hot.accept("./InformationNote.vue?vue&type=template&id=05838f2d&scoped=true", function () {
      api.rerender('05838f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassOverviewDetail/components/RemindStuDetail/components/InformationNote.vue"
export default component.exports